<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";
import Stat from "@/components/widgets/stat";
import VueMonthlyPicker from "vue-monthly-picker";

export default {
  locales: {
    pt: {
      months: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez",
      ],

      Reports: "Relatórios",
      "Bonus Totals": "Totais das Bonificações",
      Username: "Usuário",
      Name: "Nome",
      Date: "Data",
      Value: "Valor",
      Level: "Nível",
      Bonus: "Bônus",
      Status: "Status",
      Graduation: "Graduação",
      "Total Bonus": "Total de Bônus",

      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.",
      "No records found.": "Nenhum registro encontrado.",
    },
    es: {
      months: [
        "Ene",
        "Feb",
        "Mar",
        "Abr",
        "May",
        "Jun",
        "Jul",
        "Ago",
        "Sep",
        "Oct",
        "Nov",
        "Dic",
      ],

      Reports: "Reportes",
      "Bonus Totals": "Totales de Bonificaciones",
      Username: "Nombre de Usuario",
      Name: "Nombre",
      Date: "Fecha",
      Value: "Valor",
      Level: "Nivel",
      Bonus: "Bono",
      Status: "Estado",
      Graduation: "Graduación",
      "Total Bonus": "Bono Total",

      "We apologize, we are unable to retrieve information at this time. Please try again later.":
        "Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtalo de nuevo más tarde.",
      "No records found.": "No se encontraron registros.",
    },
  },
  components: {
    Layout,
    Stat,
    VueMonthlyPicker
  },
  data() {
    return {
      calendar: "",
      monthly: {
        placeHolder: this.$moment().format('MM/YYYY'),
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
      },
      date: this.$moment().format('YYYY-MM'),

      bonus: null,

      statData: null,
    };
  },
  methods: {
    showDate(date) {
      this.date = date;
    },
    getList() {
      this.bonus = null;

      api
        .get("reports/bonus?date=" + this.date)
        .then((response) => {
          if (response.data.status == "success") {
            this.bonus = response.data.list;

            this.statData = [
              {
                type: "line",
                icon: "bxs-graduation",
                title: "Graduation",
                value: response.data.graduation.name,
              },
              {
                type: "line",
                icon: "bx-dollar",
                title: "Total Bonus",
                value: this.$options.filters.currency(response.data.total),
              },
            ];
          }
        })
        .catch(() => {
          this.bonus = []
        })
    },
  },
  mounted() {
    this.getList();
  },
  watch: {
    calendar: function (v) {
      this.date = v.format('YYYY-MM');
      this.getList();
    },
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">{{ t('Reports') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>{{ t('Bonus Totals') }}</h3>
        <p></p>
      </div>
      <vue-monthly-picker v-model="calendar" dateFormat="MMM/YYYY" :placeHolder="monthly.placeHolder" :monthLabels="monthly.labels" :clearOption="false" alignment="center"></vue-monthly-picker>
    </div>

    <div class="row justify-content-center">
      <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
        <Stat :type="stat.type" :icon="stat.icon" :title="stat.title" :value="stat.value" />
      </div>
    </div>

    <div v-if="!bonus" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
    </div>

    <div v-else-if="bonus && bonus.length == 0" class="card">
      <div class="card-body min-vh-25 d-flex justify-content-center align-items-center">
        <div class="text-center">
          <i class="far fa-sad-cry font-size-24"></i><br>
          {{ t('No records found.') }}
        </div>
      </div>
    </div>

    <div v-else class="card">
      <div class="card-body py-2">
        <div class="row justify-content-center">
          <div class="col-md-6 col-lg-5 col-xl-3">
            <ul class="bonus">
              <li v-for="(row, index) in bonus" :key="index" class="d-flex justify-content-between">
                <div>
                  <h6 class="mb-0">{{ row.name }}</h6>
                </div>
                <div>
                  <h6 class="mb-0">{{ row.total | currency }}</h6>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
ul {
  list-style-type: none !important;
  margin: 0;
  padding: 0;
}
ul li {
  border-bottom: solid 1px #D1D1E3;
  padding: 12px 0;
}
ul li:last-child {
  border-bottom: none;
}
</style>